import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Table
} from 'reactstrap';

import Cargando from './../components/Cargando';
import CargandoTabla from './../components/CargandoTabla';

import Calificacion from './../api/Calificacion';

const calificacion = new Calificacion(); 

class VerMaterial extends Component {

    constructor(props){
        super(props);
        this.state = {
            usuario:this.props.user.rut,
            listado:[],
            cargando:false,
            cargandoTabla:false
        }
    }

    listadoCalificaciones = async(usuario) => {
        this.setState({cargandoTabla:true})
        let resultado = await calificacion.notasEstudiante(usuario); 
        this.setState({listado: resultado, cargando:false, cargandoTabla:false}) 
    }

    componentDidMount(){
        this.setState({cargando:true})
        this.listadoCalificaciones(this.state.usuario)
    }

    render(){

        const {listado, cargando, cargandoTabla} = this.state;
  
        return (
            <Page title="Listado calificaciones" breadcrumbs={[ { name: 'Ver calificaciones', active: true } ]}>
                <Cargando valor={cargando} visible={false}/>
                {
                    !cargandoTabla  ? (
                        listado.length>0 ? 
                        (
                            <Table bordered striped className="tabla-general tabla2">
                            <thead>
                                <tr>
                                    <th>Curso</th>
                                    <th>Actividad</th>
                                    <th className="text-center">Nota</th>
                                </tr>
                            </thead>
                            <tbody>
        
                                {listado.map((n, index)=>(
                                    <tr key={n.estudiante_id+index}>
                                        <td>{n.ciclo_nombre}</td>
                                        <td>{n.actividad_nombre}</td>
                                        <td className="text-center">{n.nota}</td>
                                    </tr>
                                ))}
                                 
                            </tbody>
                        </Table>    
                        ):(<div className="sin-registros">Sin registros</div>)
                    ): (<CargandoTabla />)
                }
            </Page>
          );
    }
 
};

export default VerMaterial;
